// extracted by mini-css-extract-plugin
export default {"cls1":"NewsInteractionBar-cls1_zVx","cls2":"NewsInteractionBar-cls2_m3n NewsInteractionBar-cls1_zVx"};